import EventEmitter from 'eventemitter3'

export const overplayTooltipEventKey = {
    show: 'SHOW-OVERLAY-TOOLTIP',
    hide: 'HIDE-OVERLAY-TOOLTIP',
}
export const overlayTooltipEvent = new EventEmitter()

export function showOverlayTooltip(target, children) {
    overlayTooltipEvent.emit(overplayTooltipEventKey.show, target, children)
}

export function hideOverlayTooltip(target) {
    overlayTooltipEvent.emit(overplayTooltipEventKey.hide, target)
}
